/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Mild_Fox_FawnInputs */

const en_sage_mild_fox_fawn = /** @type {(inputs: Sage_Mild_Fox_FawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_sage_mild_fox_fawn = /** @type {(inputs: Sage_Mild_Fox_FawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Sage_Mild_Fox_FawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_mild_fox_fawn = /** @type {((inputs?: Sage_Mild_Fox_FawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Mild_Fox_FawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_mild_fox_fawn(inputs)
	return de_sage_mild_fox_fawn(inputs)
});